import { useState } from 'react';
import { supabase } from '../supabaseClient';

export function Waitlist() {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email) {
            setError('Email is required');
            setSuccess('');
            return;
        }
        // simple email validation
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            setError('Invalid email address');
            setSuccess('');
            return;
        }

        const { data, error } = await supabase.functions.invoke('waitlist-signup', {
            body: { email: email },
        })

        if(error){
            setError(error.message);
            setSuccess('');
            return;   
        }else{
            setError('');
            setSubmitted(true);
            setSuccess('Thank you for joining the waitlist!');
        }
    };

    return (
        <section className="section has-background-white py-6 mb-6" id="waitlist">
            <div className="container mx-auto px-2 is-max-desktop">
                <div className="box mx-auto" style={{
                    border: "1px solid gray",
                    maxWidth: "42rem",

                }}>
                    {!submitted ? (
                        <>
                            <div className="has-text-centered mb-6">
                                <span className="icon is-large p-6 mb-3" style={{
                                    background: "linear-gradient(135deg, #667eea1a 0%, #764ba21a 100%)",
                                    borderRadius: "8px"
                                }}>
                                    <i className="fa-regular fa-2x fa-envelope"></i>
                                </span>
                                <h1 className="is-size-5 has-text-centered mb-3">Join the Waitlist</h1>
                                <p className="has-text-grey">
                                    Be among the first to experience the future of zero-knowledge development.
                                </p>
                            </div>
                            <form onSubmit={handleSubmit}>
                                <div className="field mb-3">
                                    <label className="label has-text-weight-semibold mb-2">Email address</label>
                                    <div className="control has-icons-left">
                                        <input
                                            className="input is-medium"
                                            type="email"
                                            placeholder="you@company.com"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                        />
                                        <span className="icon is-small is-left">
                                            <i className="fas fa-envelope"></i>
                                        </span>
                                    </div>
                                </div>
                                <div className="field mb-3">
                                    <div className="control">
                                        <button type="submit" className="button is-link is-fullwidth is-medium">
                                            Join Waitlist
                                        </button>
                                    </div>
                                </div>
                                {error && <p className="help is-danger">{error}</p>}
                            </form>
                        </>
                    ) : (
                        <>
                            <div className="has-text-centered mb-6">
                                <span className="icon is-large p-6 mb-3 has-text-success" style={{
                                    // background: "linear-gradient(135deg, #667eea1a 0%, #764ba21a 100%)",
                                    borderRadius: "8px"
                                }}>
                                    <i className="fa-regular fa-2xl fa-circle-check"></i>
                                </span>
                                <h1 className="is-size-5 has-text-centered mb-3">You're on the list!</h1>
                                <p className="">
                                    {success} We'll send you an email at{" "}
                                    <span className="has-text-weight-bold">{email}</span>{" "}
                                    when we're ready to launch.
                                </p>

                                <button className="button px-6 py-3 mt-2"
                                    onClick={() => {
                                        setSubmitted(false);
                                        setEmail("");
                                    }}
                                >
                                    Submit another
                                </button>
                            </div>
                        </>
                    )}
                </div>

                {/* Benefits */}
                {!submitted && (
                    <div className="fixed-grid has-3-cols mx-auto" style={{ maxWidth: "42rem" }}>
                        <div className="grid is-gap-4 mt-2">
                            <div className="has-text-centered">
                                <span className="icon mb-3 has-text-danger is-medium">
                                    <i className="fas fa-lg fa-bolt"></i>
                                </span>
                                <p className="has-text-weight-medium is-size-6 mb-1">Early Access</p>
                                <p className="is-size-6 has-text-grey">First to try features</p>
                            </div>
                            <div className="has-text-centered">
                                <span className="icon has-text-danger is-medium mb-3">
                                    <i className="fas fa-lg fa-newspaper"></i>
                                </span>
                                <p className="has-text-weight-medium is-size-6 mb-1">Exclusive Updates</p>
                                <p className="is-size-6 has-text-grey">Development insights</p>
                            </div>
                            <div className="has-text-centered">
                                <span className="icon has-text-danger is-medium mb-3">
                                    <i className="fas fa-lg fa-tag"></i>
                                </span>
                                <p className="has-text-weight-medium is-size-6 mb-1">Special Pricing</p>
                                <p className="is-size-6 has-text-grey">Launch discount</p>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
};
